import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import daysdetails from './images/daysdetails.jpg'; 
import dropbox from './images/dropbox.jpg'; 
import dropboximages from './images/dropboximages.jpg'; 
import exercise from './images/exercise.jpg';  
import googlefit from './images/googlefit.jpg';  
import oura from './images/oura.jpg';  
import sleep from './images/sleep.jpg'; 

function HelpTips() {
  return (
    <main id="helpTips" className="textPage">
      <h1>Ohjeet - Sensotrend Dashboard</h1>
      <ul className="toc">
        <li><Link to="/help">Etusivulle</Link></li>
        <br />         
        <li><Link to="/helpIntro">Palvelun esittely</Link></li> 
        <li><Link to="/helpGuidance">Käyttöohjeet</Link></li>
        <li><big><b>Tiedon hyödyntäminen</b></big></li>
        <br /> 
        <li><Link to="/helpForPractitioner">Ammattilaisille</Link></li>
      </ul>
      <h1>Tiedon hyödyntäminen</h1>
      <p>Lukuaika noin 8 min.</p>
      <ul>
        <li><Link to="#balance">Glukoositasapainoon vaikuttavista tekijöistä oppiminen</Link></li>
        <li><Link to="#images">Ateriakuvien lisääminen palveluun</Link></li>
        <li><Link to="#exercise">Liikuntatiedon lisääminen palveluun</Link></li>
        <li><Link to="#oura">Ouran tietojen lisääminen palveluun</Link></li>
      </ul>
      <section id="balance">
        <h2>Glukoositasapainoon vaikuttavista tekijöistä oppiminen</h2>
        <p>
          <Link to="#helpTips">Takaisin alkuun</Link>
        </p>
        <p>
          Tämän diabetesliiton <a
          href="https://diabeteslehti.diabetes.fi/blog/2020/09/03/osaatko-hyodyntaa-sensorin-purkudatan-tietoja/"
          >artikkelin</a> avulla voit oppia perusasiat laitteidesi tuottaman tiedon
          hyödyntämisestä.
        </p>
      </section>
      {/*
        <section>
          <h2>Liikunnan vaikutus</h2>
        </section>
        <section>
          <h2>Vireystilan seuraaminen</h2>
        </section>
      */}
      <section id="images">
        <h2>Ateriakuvien lisääminen palveluun</h2>
        <p>
          <Link to="#helpTips">Takaisin alkuun</Link>
        </p>
        <p>
          Ateriakuvien lisääminen palveluun tapahtuu Dropboxin kautta. 
        </p>
        <p>
          Jotta kuvat saadaan näkyviin Sensotrendin palvelussa, pitää ensin muodostaa liitos Sensotrendin
          palvelun ja Dropboxin välille. Kun klikkaat Sensotrend Dashboardin oikeassa yläkulmassa näkyvää
          nimeäsi ja valitset valikosta "Tietolähteet", avautuu Tietolähteet-sivu, jonka vasemmasta 
          alakulmasta löytyy Dropbox.
        </p>
        <p>
          Dropboxin ja Sensotrendin palvelun välinen liitos muodostetaan seuraavalla tavalla:<br />
          <ol>
            <li>
              Liitoksen muodostaminen alkaa painamalla Dropboxin kohdalla olevaa "LIITÄ!"-nappia.
            </li>
            <li>
              Kirjaudu Dropbox-palveluun valitsemallasi tavalla. Jos sinulla ei vielä ole Dropbox-tiliä, 
              voit luoda sen sivun alareunassa olevasta linkistä.
            </li>
            <li>
              Salli Dropboxille pääsy tilillesi. Tässä esimerkissä kirjautuminen on tapahtunut 
              Google-tunnuksilla. Muilla tunnuksilla kirjauduttaessa ikkuna saattaa poiketa hieman
              tässä esitetystä.
            </li>
            <li>
              Liitos on kirjautumisen jälkeen valmis ja sen merkkinä käyttäjänimesi näkyy Sensotrendin 
              Dashboardin "Tietolähteet"-sivulla Dropboxin kohdalla.
            </li>
          </ol>
        </p>
        <p>
          <img src={dropbox} alt="Dropbox yhteyden muodostaminen." />
        </p>
        <p>
          Kun liitit Dropboxin Sensotrendin palveluun, luotiin Dropboxiisi alla olevan kuvan 
          mukainen "Sensotrend Shared Folder"-kansio, joka löytyy "Apps"-kansion alta. Jotta
          ateriakuvat näkyvät Sensotrendin palvelussa, tulee ne tallentaa tähän kansioon.
        </p>
        <p>
          Ateriakuvat voit ottaa millä tahansa kameralla. Suosittelemme, että kameran asetuksissa
          kuvien nimeämiseksi valitaan nimeäminen kuvausajan perusteelle, kuten alla olevassa
          esimerkkikuvassa on tehty. Tällöin Sensotrendin palvelu osaa sijoittaa kuvat automaattisesti
          oikean ajan kohdalle. Jos kuvausaikaa ei löydy tiedoston nimestä, sijoittaa Sensotrend 
          Dashboard kuvat tiedoston viimeisen muokkausajan kohdalle.
        </p>
        <p>
          <img src={dropboximages} alt="Ateriakuvat Dropboxissa." />
        </p>
        <p>
          Kun ateriakuvat on onnistuneesti tuotu Sensotrendin palveluun, ne näkyvät Päivänäkymän
          "muistiinpanot"-rivillä. Ateriakuvat saa suurennettua klikkaamalla "muistiinpanot"-rivillä
          näkyviä pieniä kuvakkeita.
        </p>
        <p>              
          Koska ateriakuvat näkyvät ajallisesti samalla kohdalla tehtyjen hiilihydraattimerkintöjen 
          ja insuliiniannosten kanssa, on niitä helppo verrata toisiinsa. Myös 
          verensokeriarvojen muutokset aterian jälkeen näkee tässä esitysmuodossa helposti,
          mikä mahdolistaa omaan hoitotasapainoon vaikuttavista ruokailutottumuksista oppimisen 
          ja paremman hoitotasapainon saavuttamisen ruokailutottumuksia muuttamalla.
        </p>
        <p>
          <img src={daysdetails} alt="Ateriakuvat Päivänäkymässä." />
        </p>
      </section>
      <section id="exercise">
        <h2>Liikuntatiedon lisääminen palveluun</h2>
        <p>
          <Link to="#helpTips">Takaisin alkuun</Link>
        </p>
        <p>
          Liikuntatiedon lisääminen tapahtuu Google FIT -palvelun kautta. 
        </p>
        <p>
          Jotta liikuntatiedot saadaan näkyviin Sensotrendin palvelussa, pitää ensin muodostaa liitos 
          Sensotrendin palvelun ja Google FIT -palvelun välille. Kun klikkaat Sensotrend Dashboardin 
          oikeassa yläkulmassa näkyvää nimeäsi ja valitset valikosta "Tietolähteet", avautuu 
          Tietolähteet-sivu, jonka alaosasta keskeltä löytyy Google FIT.
        </p>
        <p>
          Google FIT -palvelun ja Sensotrendin välinen liitos muodostetaan seuraavalla tavalla:<br />
          <ol>
            <li>
              Liitoksen muodostaminen alkaa painamalla Google FIT -palvelun kohdalla olevaa "LIITÄ!"-nappia.
            </li>
            <li>
              Kirjaudu Google-tilillesi. Jos sinulla ei vielä ole Google-tiliä, voit luoda sen sivun
              vasemmassa alakulmassa olevasta "Luo tili" -linkistä.
            </li>
            <li>
              Liitos on kirjautumisen jälkeen valmis ja sen merkkinä käyttäjänimesi näkyy Sensotrendin Dashboardin 
              "Tietolähteet"-sivulla Google FIT -palvelun kohdalla.
            </li>
          </ol>
        </p>
        <p>
          <img src={googlefit} alt="Google FIT palvelun liittäminen." />
        </p>
        <p>
          Kun Google FIT -palvelun ja Sensotrendin välinen liitos on muodostettu onnistuneesti, näkyvät 
          Google FIT -palveluun tallentamasi liikuntatiedot Sensotrend Dashboardin Päivänäkymän
          "aktiivisuus"-rivillä. Tämän näkymän tarjoama liikuntatiedon yhdistäminen muihin tallentamiisi 
          tietoihin mahdollistaa oppimisen liikunnan vaikutuksesta hoitotasapainoosi.
        </p>
        <p>
          <img src={exercise} alt="Liikuntatiedot Päivänäkymässä." />
        </p>
      </section>
      <section id="oura">
        <h2>Ouran tietojen lisääminen palveluun</h2>
        <p>
          <Link to="#helpTips">Takaisin alkuun</Link>
        </p>
        <p>
          Ouran tuottamien tietojen avulla saat tarkempaa tietoa unestasi ja palautumisestasi. 
        </p>
        <p>
          Jotta Ouran tuottamat tiedot saadaan näkyviin Sensotrendin palvelussa, pitää ensin muodostaa liitos 
          Sensotrendin palvelun ja Ouran pilvipalvelun välille. Kun klikkaat Sensotrend Dashboardin 
          oikeassa yläkulmassa näkyvää nimeäsi ja valitset valikosta "Tietolähteet", avautuu 
          Tietolähteet-sivu, jonka oikeasta alakulmasta löytyy Oura.
        </p>
        <p>
          Oura-palvelun ja Sensotrendin välinen liitos muodostetaan seuraavalla tavalla:<br />
          <ol>
            <li>
              Liitoksen muodostaminen alkaa painamalla Ouran kohdalla olevaa "LIITÄ!"-nappia.
            </li>
            <li>
              Kirjaudu Oura-tilillesi. Jos sinulla ei vielä ole Oura-tiliä, saat sen hankkimalla Oura-sormuksen.
              Tarkempia tietoja saat Ouran verkkosivustolta, johon on linkki kirjautumissivulta.
            </li>
            <li>
              Liitos on kirjautumisen jälkeen valmis ja sen merkkinä käyttäjänimesi näkyy Sensotrendin Dashboardin 
              "Tietolähteet"-sivulla Ouran kohdalla.
            </li>
          </ol>
        </p>
        <p>
          <img src={oura} alt="Ouran pilvipalvelun liittäminen." />
        </p>
        <p>
          Kun Ouran pilvipalvelun ja Sensotrendin välinen liitos on muodostettu onnistuneesti, näkyvät 
          Ouran tuottamat tiedot Sensotrend Dashboardin Päivänäkymän "aktiivisuus"-rivillä sinisenä palkkina
          ja sitä selittävän tekstinä. 
        </p>
        <p>
          <img src={sleep} alt="Oura tuottama tieto Päivänäkymässä." />
        </p>
      </section>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default HelpTips;